module.exports = {
  "grid-select": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "flexWrap": "wrap"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-dec66500!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-grid-select/index.vue
// module id = 553
// module chunks = 0 1